import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, PhoneIncoming, AlertTriangle, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { COMPANY } from "@/lib/constants";
import { useVisitorTracking } from "@/hooks/useVisitorTracking";
import QuickCallbackForm from "@/components/shared/QuickCallbackForm";

const StickyMobileCTA = () => {
  const { trackCTAClick } = useVisitorTracking();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const isGA = location.pathname.startsWith("/roofing/ga") || location.pathname.startsWith("/roofing/georgia") || location.pathname.startsWith("/georgia-");
  const phoneNumber = isGA ? COMPANY.gaPhone.replace(/-/g, '') : COMPANY.phone.replace(/-/g, '');
  const phoneHref = isGA ? COMPANY.gaPhoneHref : COMPANY.phoneHref;
  const smsHref = `sms:+1${phoneNumber}?body=${encodeURIComponent("Hi, I'd like to request a roof inspection. My name is ")}`;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-t border-border shadow-lg z-40 md:hidden">
        <div className="flex justify-around items-center py-2 px-2 gap-1.5 safe-area-inset-bottom">
          <a href={phoneHref} className="flex-1" onClick={() => trackCTAClick('Call', 'sticky_cta')}>
            <Button variant="default" size="sm" className="w-full gap-1">
              <Phone className="h-4 w-4" />
              <span className="text-xs">Call</span>
            </Button>
          </a>
          <a href={smsHref} className="flex-1" onClick={() => trackCTAClick('Text', 'sticky_cta')}>
            <Button variant="outline" size="sm" className="w-full gap-1">
              <MessageSquare className="h-4 w-4" />
              <span className="text-xs">Text</span>
            </Button>
          </a>
          <Button variant="accent" size="sm" className="flex-1 gap-1" onClick={() => { trackCTAClick('Call Me Back', 'sticky_cta'); setOpen(true); }}>
            <PhoneIncoming className="h-4 w-4" />
            <span className="text-xs">Call Me</span>
          </Button>
          <Link to="/emergency" className="flex-1" onClick={() => trackCTAClick('Emergency', 'sticky_cta')}>
            <Button variant="destructive" size="sm" className="w-full gap-1">
              <AlertTriangle className="h-4 w-4" />
              <span className="text-xs">SOS</span>
            </Button>
          </Link>
        </div>
      </div>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-2xl">
          <SheetHeader className="text-left mb-4">
            <SheetTitle>Request a Roof Inspection</SheetTitle>
            <SheetDescription>Leave your name and number and we'll call you back.</SheetDescription>
          </SheetHeader>
          <QuickCallbackForm source="mobile-callback-sheet" onDone={() => setOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  );
};

export default StickyMobileCTA;
